<template>
    <div id="login">
        <header-comp v-if="showHeader"></header-comp>
        <div class="wrap">
            <div class="login-section">
                <img class="web-logo" src="@/assets/img/flypig.svg" alt="">
                <button class="border-button" @mouseenter="showQr=true" @mouseleave="showQr=false">
                    App 下載
                    <qr-download v-if="showQr"></qr-download>
                </button>
                <div class="intro">
                    <span class="maybe"></span>
                    <span class="best">最好的房屋租賃管理系統</span>
                    <img class="house-keeper" src="@/assets/img/pages/login/slogan.svg" alt="">
                    <span class="description">飛豬管家是專門為屋主設計的專業管理平台，充分了解屋主的痛點，提供深度的解決方案，貫穿從上架房源到租客退房的所有細節，飛豬管家幫您一手掌握。</span>
                </div>
                <login-comp></login-comp>
                <img class="plant" src="@/assets/img/pages/login/plant.svg" alt="飛豬管家" srcset="">
            </div>
            <div class="describe-section features">
                <span class="title">
                    <img src="@/assets/img/pages/login/house_user.svg" alt="">
                    產品特色
                </span>
                <h1>選擇飛豬管家的理由</h1>
                <product-intro></product-intro>
            </div>
            <div class="describe-section scenarios">
                <span class="title">
                    <img src="@/assets/img/pages/login/house_user.svg" alt="">
                    使用情境
                </span>
                <h1>免費體驗飛豬管家</h1>
                <div class="steps-wrap">
                    <span class="one">既有房源</span>
                    <span class="two">手機登入</span>
                    <span class="three">下載 App</span>
                    <span class="four">立即體驗</span>
                    <img class="step-img" src="@/assets/img/pages/login/steps.svg" alt="" srcset="">
                    <img class="step-img-mb" src="@/assets/img/pages/login/steps_mb.svg" alt="" srcset="">
                </div>
            </div>
        </div>
        <footer-comp></footer-comp>
    </div>     
</template>
<script>
import LoginComp from '@/components/login/LoginComp.vue';
import ProductIntro from '@/components/login/ProductIntro.vue';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import QrDownload from '@/components/widge/QrDownload.vue';
import { mapGetters } from 'vuex'

export default {
    name: 'Login',
    data () {
        return {
            showHeader: false,
            showQr: false
        }
    },
    mounted () {
        this.$router.push('/')
        // document.getElementById('register').onClick = function () {
        //     document.body.scrollTop = document.documentElement.scrollTop = 0;
        // }
        window.addEventListener('scroll', this.handleScroll);

        if(this.system != 'pc'){
            this.showHeader = true
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            
            // console.log(scrollTop)
            if(this.system == 'pc'){
                if( scrollTop >= 700){
                    this.showHeader = true
                }else{
                    this.showHeader = false
                }
            }else{
                this.showHeader = true
                if( scrollTop >= 700){
                    document.getElementById('register').style.display = 'initial'
                }else{
                    document.getElementById('register').style.display = 'none'
                }
            }
            
        },
    },
    computed: {
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
        })
    },
    components: {
        LoginComp,
        ProductIntro,
        QrDownload,
        'header-comp': Header,
        'footer-comp': Footer
    }
}
</script>
<style lang="scss" scoped>
    #login{
        .wrap{
            .login-section{
                position: relative;
                width: 1440px;
                height: 740px;
                background-image: url('../assets/img/pages/login/login_section.svg');
                display: flex;
                .web-logo{
                    position: absolute;
                    width: 60px;
                    height: 60px;
                    top: 40px;
                    left: 90px;
                }
                .border-button{
                    position: absolute;
                    top: 40px;
                    right: 90px;
                    width: 124px;
                    font-size: 16px;
                    font-weight: 500;
                    .qr-download{
                        top: 47px;
                        right: -2px;
                    }
                }
                .intro{
                    position: absolute;
                    top: 164px;
                    left: 220px;
                    width: 390px;
                    display: flex;
                    flex-direction: column;
                    text-align: center;
                    .maybe{
                        position: relative;
                        font-size: 12px;
                        margin-bottom: 16px;
                        color: #a8a5a4;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        span{
                            padding: 0 12px;
                            font-size: 20px;
                            color: #ffd9bf;
                        }
                    }
                    .maybe::before{
                        content: '';
                        position: absolute;
                        display: block;
                        height: 8px;
                        width: 210px;
                        border-radius: 1px;
                        background-color: #ffd9bf;
                        left: 107px;
                        bottom: -57px;
                    }
                    .best{
                        position: relative;
                        font-size: 36px;
                        letter-spacing: -0.6px;
                        margin-bottom: 34px;
                        z-index: 1;
                    }
                    .house-keeper{
                        position: relative;
                        margin-bottom: 29px;
                    }
                    .description{
                        font-size: 20px;
                        line-height: 1.6;
                        text-align: left;
                    }
                }
                .login-form{
                    position: absolute;
                    top: 144px;
                    right: 166px;
                }
                .plant{
                    position: absolute;
                    right: 79px;
                    bottom: 114px;
                }
            }
            .describe-section{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding-top: 120px;
                padding-bottom: 40px;
                background-color: #f6f6f6;
                >.title{
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    color: #ff9275;
                    margin-bottom: 16px;
                    img{
                        margin-right: 12px;
                    }
                    
                }
                >h1{
                    font-size: 36px;
                }
            }
            .features{
                .product-intro{
                    margin-top: 40px;
                }
            }
            .scenarios{
                .steps-wrap{
                    position: relative;
                    margin-top: 80px;
                    margin-bottom: 120px;
                    .step-img-mb{
                        display: none;
                    }
                    span{
                        position: absolute;
                        font-size: 16px;
                        font-weight: 500;
                        color: #ffffff;
                    }
                    .one{
                        right: 395px;
                        top: 151px;
                    }
                    .two{
                        left: 266px;
                        top: 285px;
                    }
                    .three{
                        right: 393px;
                        top: 400px;
                    }
                    .four{
                        left: 266px;
                        top: 514px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        #login{
            .wrap{
                .login-section{
                    width: 1280px;
                    height: 740px;
                    background-image: url('../assets/img/pages/login/login_section_1280.svg');
                    display: flex;
                    .web-logo {
                        left: 59px;
                    }
                    .border-button {
                        right: 59px;
                    }
                    .login-form {
                        right: 100px;
                    }
                    .plant{
                        right: 49px;
                    }
                }
            }
        }    
    }
    @media screen and (max-width: 500px) {
        #login{
            #header{
                .default-button{
                    display: none;
                }
            }
            .wrap{
                .login-section{
                    position: relative;
                    width: 100%;
                    height: 100%;
                    padding-bottom: 20px;
                    background-image: none;
                    display: block;
                    background: #ffe9e3;
                    .web-logo{
                        display: none;
                    }
                    .border-button{
                        display: none;
                        .qr-download{
                            display: none;
                        }
                    }
                    .intro{
                        position: relative;
                        top: unset;
                        left: unset;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        background: #fff;
                        margin-bottom: 20px;
                        padding-top: 75px;
                        .maybe{
                            font-size: 12px;
                            margin-bottom: 12px;
                            span{
                                padding: 0 8px;
                                font-size: 14px;
                            }
                        }
                        .maybe::before{
                            content: '';
                            height: 6px;
                            width: 158px;
                            left: 35%;
                            bottom: -45px;
                        }
                        .best{
                            position: relative;
                            font-size: 28px;
                            letter-spacing: -0.6px;
                            margin-bottom: 18px;
                            z-index: 1;
                        }
                        .house-keeper{
                            position: relative;
                            width: 70%;
                            margin: 0 auto 30px;
                        }
                        .description{
                            display: none;
                        }
                    }
                    .login-form{
                        position: relative;
                        top: unset;
                        right: unset;
                        margin: 0 auto;
                    }
                    .plant{
                        display: none;
                    }
                }
                .describe-section{
                    padding-top: 31px;
                    padding-bottom: 31px;
                    >.title{
                        font-size: 14px;
                        margin-bottom: 14px;
                        img{
                            margin-right: 12px;
                        }
                        
                    }
                    >h1{
                        font-size: 28px;
                    }
                }
                .features{
                    .product-intro{
                        margin-top: 40px;
                    }
                }
                .scenarios{
                    .steps-wrap{
                        margin-top: 20px;
                        margin-bottom: 65px;
                        span{
                            font-size: 14px;
                        }
                        .one{
                            right: 35%;
                            top: 19.8%;
                        }
                        .two{
                            left: 30%;
                            top: 38.5%;
                        }
                        .three{
                            right: 35%;
                            top: 54.3%;
                        }
                        .four{
                            left: 30%;
                            top: 69.7%;
                        }
                        img{
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 375px) {
        #login{
            .wrap{
                .login-section{
                    .intro{
                        .maybe::before{
                           content: '';
                            height: 6px;
                            width: 163px;
                            left: 33%;
                            bottom: -44px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 360px) {
        #login{
            .wrap{
                .login-section{
                    .intro{
                        .best{
                            position: relative;
                            font-size: 24px;
                            letter-spacing: -0.6px;
                            margin-bottom: 24px;
                            z-index: 1;
                        }
                        .maybe::before{
                           content: '';
                            height: 6px;
                            width: 140px;
                            left: 122px;
                            bottom: -41px;
                        }
                        .house-keeper{
                            width: 84%;
                        }
                    }
                }
                .describe-section{
                    >.title{
                        margin-bottom: 18px;
                    }
                    >h1{
                        font-size: 24px;
                    }
                }
                .features{
                    .product-intro{
                        margin-top: 30px;
                    }
                }
                .scenarios{
                    .steps-wrap{
                        margin-top: 30px;
                        margin-bottom: 20px;
                        .step-img{
                            display: none;
                        }
                        .step-img-mb{
                            display: initial;
                        }
                        span{
                            font-size: 12px;
                        }
                        .one{
                            right: 33%;
                            top: 14.8%;
                        }
                        .two{
                            left: 21%;
                            top: 39.5%;
                        }
                        .three{
                            right: 33%;
                            top: 59.3%;
                        }
                        .four{
                            left: 21%;
                            top: 80.7%;
                        }
                        img{
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 320px) {
        #login{
            .wrap{
                .login-section{
                    .intro{
                        .maybe::before{
                           content: '';
                            height: 6px;
                            width: 140px;
                            left: 104px;
                            bottom: -41px;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/Login.vue